import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const OncologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.0713 40C80.0713 61.8153 62.3865 79.5 40.5713 79.5C18.756 79.5 1.07129 61.8153 1.07129 40C1.07129 18.1848 18.756 0.5 40.5713 0.5C62.3865 0.5 80.0713 18.1848 80.0713 40Z'
    />
    <g clipPath='url(#clip0_414_9712)'>
      <path
        d='M39.5517 19.9924C42.0308 22.7112 43.51 25.7528 42.7913 28.9924C37.4163 25.8987 30.8225 25.8987 25.4579 28.9924C24.9996 25.6695 25.9996 22.5758 28.26 19.9924C32.135 18.7112 35.9059 18.6279 39.5517 19.9924Z'
        fill='#ED1B1B'
      />
      <path
        d='M51.6042 52.3466L45.4271 60.6591C45.1354 61.0445 44.6146 61.1903 44.1771 61.0028C29.2292 54.6174 20.6562 41.7945 20.6562 31.1383C20.6562 26.3153 23.6979 21.6799 28.2604 19.9924C25.8854 22.7008 25.3333 26.7528 26.2604 30.2633C27.2396 33.982 29.6458 37.1695 32.375 39.8778C37.5312 45.0133 44.0312 48.7737 51.0312 50.7216C51.7396 50.9195 52.0521 51.7528 51.6042 52.3466Z'
        fill='#F92626'
      />
      <path
        opacity='0.05'
        d='M46.8437 58.7528L45.4271 60.6591C45.1354 61.0445 44.6146 61.1903 44.1771 61.0028C29.2292 54.6174 20.6562 41.7945 20.6562 31.1278C20.6562 27.357 22.5104 23.7112 25.5 21.4924C23.9375 23.5549 23.0312 26.1383 23.0312 28.7633C23.0312 39.482 31.7187 52.3987 46.8437 58.7528Z'
        fill='black'
      />
      <path
        d='M16.2083 52.3466L22.3854 60.6591C22.6771 61.0445 23.1979 61.1903 23.6354 61.0028C38.5833 54.6174 47.1563 41.7945 47.1563 31.1383C47.1563 26.3153 44.1146 21.6799 39.5521 19.9924C41.9271 22.7008 42.4792 26.7528 41.5521 30.2633C40.5729 33.982 38.1667 37.1695 35.4375 39.8778C30.2813 45.0133 23.7813 48.7737 16.7813 50.7216C16.0729 50.9195 15.7604 51.7528 16.2083 52.3466Z'
        fill='#FF3333'
      />
      <path
        opacity='0.1'
        d='M47.1562 31.1279C47.1562 41.7946 38.5833 54.6071 23.6354 61.0029C23.1875 61.1904 22.6667 61.0446 22.3854 60.6592L20.8438 58.5863C35.9583 52.2425 44.6354 39.3363 44.6354 28.6071C44.6354 26.0238 43.7604 23.4925 42.2396 21.4404C45.2708 23.6488 47.1562 27.3363 47.1562 31.1279Z'
        fill='white'
      />
      <path
        d='M66.0002 34.18C66.0002 39.0342 62.0627 42.9613 57.1981 42.9613C52.3439 42.9613 48.396 39.0342 48.396 34.18C48.396 29.3258 52.3335 25.3779 57.1981 25.3779C62.0627 25.3779 66.0002 29.3258 66.0002 34.18Z'
        fill='#EDEDED'
      />
      <path d='M53.7083 41.6382L47.75 43.6278L49.7396 37.6694L53.7083 41.6382Z' fill='#EDEDED' />
      <path
        opacity='0.05'
        d='M66 34.1696C66 39.0342 62.0625 42.9613 57.2083 42.9613C55.2708 42.9613 53.4792 42.3363 52.0312 41.2842C53.0729 41.7113 54.2083 41.9508 55.4063 41.9508C60.2708 41.9508 64.2083 38.0238 64.2083 33.1696C64.2083 30.2321 62.7708 27.6383 60.5625 26.0342C63.75 27.3571 66 30.5029 66 34.1696Z'
        fill='black'
      />
      <path
        d='M57.7706 27.6489C57.8331 28.0447 57.4998 28.3676 57.1039 28.3051C56.8643 28.2634 56.6664 28.0655 56.6248 27.8259C56.5623 27.4405 56.8956 27.1072 57.281 27.1697C57.531 27.2114 57.7289 27.4093 57.7706 27.6489Z'
        fill='#45A80B'
      />
      <path
        d='M57.3958 27.8469V29.1386C57.3958 29.2428 57.3125 29.3365 57.1979 29.3365C57.0937 29.3365 57 29.2532 57 29.1386V27.8469H57.3958Z'
        fill='#45A80B'
      />
      <path
        d='M56.635 40.6904C56.5725 40.2946 56.9059 39.9716 57.3017 40.0341C57.5413 40.0758 57.7392 40.2737 57.7809 40.5133C57.8434 40.8987 57.51 41.2321 57.1246 41.1696C56.8746 41.1279 56.6767 40.93 56.635 40.6904Z'
        fill='#45A80B'
      />
      <path
        d='M56.9995 40.4928V39.2011C56.9995 39.0969 57.0828 39.0032 57.1974 39.0032C57.3016 39.0032 57.3953 39.0865 57.3953 39.2011V40.4928H56.9995Z'
        fill='#45A80B'
      />
      <path
        d='M52.9896 29.1591C53.3125 29.3883 53.3125 29.8675 52.9896 30.0966C52.7917 30.2425 52.5104 30.2425 52.3125 30.0966C52 29.8675 52 29.3987 52.3125 29.1695C52.5208 29.0133 52.7917 29.0133 52.9896 29.1591Z'
        fill='#45A80B'
      />
      <path
        d='M52.875 29.5654L53.7917 30.4821C53.8646 30.555 53.8646 30.68 53.7917 30.7633C53.7187 30.8363 53.5937 30.8363 53.5104 30.7633L52.5938 29.8467L52.875 29.5654Z'
        fill='#45A80B'
      />
      <path
        d='M61.4067 39.1802C61.0838 38.951 61.0838 38.4718 61.4067 38.2427C61.6047 38.0968 61.8859 38.0968 62.0838 38.2427C62.3963 38.4718 62.3963 38.9406 62.0838 39.1698C61.8859 39.326 61.6047 39.326 61.4067 39.1802Z'
        fill='#45A80B'
      />
      <path
        d='M61.5314 38.7736L60.6147 37.8569C60.5418 37.784 60.5418 37.659 60.6147 37.5757C60.6877 37.5028 60.8127 37.5028 60.896 37.5757L61.8127 38.4924L61.5314 38.7736Z'
        fill='#45A80B'
      />
      <path
        d='M50.6772 33.6074C51.073 33.5449 51.3959 33.8783 51.3334 34.2741C51.2918 34.5137 51.0938 34.7116 50.8543 34.7533C50.4688 34.8158 50.1355 34.4824 50.198 34.097C50.2397 33.8366 50.4376 33.6387 50.6772 33.6074Z'
        fill='#45A80B'
      />
      <path
        d='M50.8853 33.9722H52.1769C52.2811 33.9722 52.3748 34.0555 52.3748 34.1701C52.3748 34.2743 52.2915 34.368 52.1769 34.368H50.8853V33.9722Z'
        fill='#45A80B'
      />
      <path
        d='M63.7192 34.7428C63.3234 34.8053 63.0005 34.4719 63.063 34.0761C63.1046 33.8365 63.3025 33.6386 63.5421 33.5969C63.9275 33.5344 64.2609 33.8678 64.1984 34.2532C64.1671 34.5032 63.9692 34.7011 63.7192 34.7428Z'
        fill='#45A80B'
      />
      <path
        d='M63.5208 34.3678H62.2292C62.125 34.3678 62.0312 34.2844 62.0312 34.1698C62.0312 34.0657 62.1146 33.9719 62.2292 33.9719H63.5208V34.3678Z'
        fill='#45A80B'
      />
      <path
        d='M52.1877 38.3779C52.4169 38.055 52.896 38.055 53.1252 38.3779C53.271 38.5758 53.271 38.8571 53.1252 39.055C52.896 39.3675 52.4273 39.3675 52.1981 39.055C52.0419 38.8571 52.0419 38.5758 52.1877 38.3779Z'
        fill='#45A80B'
      />
      <path
        d='M52.5938 38.5031L53.5104 37.5864C53.5833 37.5135 53.7083 37.5135 53.7917 37.5864C53.8646 37.6593 53.8646 37.7843 53.7917 37.8677L52.875 38.7843L52.5938 38.5031Z'
        fill='#45A80B'
      />
      <path
        d='M62.2187 29.9615C61.9896 30.2844 61.5104 30.2844 61.2812 29.9615C61.1354 29.7636 61.1354 29.4823 61.2812 29.2844C61.5104 28.9719 61.9792 28.9719 62.2083 29.2844C62.3542 29.4823 62.3542 29.7636 62.2187 29.9615Z'
        fill='#45A80B'
      />
      <path
        d='M61.8127 29.8364L60.896 30.7531C60.8231 30.826 60.6981 30.826 60.6147 30.7531C60.5418 30.6802 60.5418 30.5552 60.6147 30.4718L61.5314 29.5552L61.8127 29.8364Z'
        fill='#45A80B'
      />
      <path
        d='M62.6457 34.1698C62.6457 37.1803 60.2082 39.6178 57.2082 39.6178C54.1978 39.6178 51.7603 37.1803 51.7603 34.1698C51.7603 31.1594 54.1978 28.7219 57.2082 28.7219C60.2082 28.7219 62.6457 31.1594 62.6457 34.1698Z'
        fill='#5FBA24'
      />
      <path
        d='M57.7706 30.8676C57.8331 31.2634 57.4998 31.5864 57.1039 31.5239C56.8643 31.4822 56.6664 31.2843 56.6248 31.0447C56.5623 30.6593 56.8956 30.3259 57.281 30.3884C57.531 30.4197 57.7289 30.6176 57.7706 30.8676Z'
        fill='#45A80B'
      />
      <path
        d='M55.7706 37.0449C55.8331 37.4407 55.4998 37.7636 55.1039 37.7011C54.8643 37.6594 54.6664 37.4615 54.6248 37.2219C54.5623 36.8365 54.8956 36.5032 55.281 36.5657C55.5414 36.5969 55.7393 36.7949 55.7706 37.0449Z'
        fill='#45A80B'
      />
      <path
        d='M60.2711 31.6384C60.3336 32.0342 60.0003 32.3571 59.6044 32.2946C59.3648 32.2529 59.1669 32.055 59.1253 31.8154C59.0628 31.43 59.3961 31.0967 59.7815 31.1592C60.0419 31.2009 60.2398 31.3988 60.2711 31.6384Z'
        fill='#45A80B'
      />
      <path
        d='M60.7291 36.8574C60.7916 37.2532 60.4583 37.5761 60.0624 37.5136C59.8228 37.4719 59.6249 37.274 59.5833 37.0344C59.5208 36.649 59.8541 36.3157 60.2395 36.3782C60.4999 36.4199 60.6978 36.6178 60.7291 36.8574Z'
        fill='#45A80B'
      />
      <path
        d='M54.4166 33.6071C54.4791 34.0029 54.1458 34.3259 53.7499 34.2634C53.5103 34.2217 53.3124 34.0238 53.2708 33.7842C53.2083 33.3988 53.5416 33.0654 53.927 33.1279C54.177 33.1696 54.3749 33.3675 54.4166 33.6071Z'
        fill='#45A80B'
      />
      <path
        d='M58.8749 34.0032C58.9791 34.6907 58.3958 35.2636 57.7187 35.1594C57.2916 35.0969 56.9478 34.7428 56.8853 34.3261C56.7812 33.649 57.3541 33.0761 58.0312 33.1803C58.4583 33.2428 58.802 33.5865 58.8749 34.0032Z'
        fill='#45A80B'
      />
      <path
        opacity='0.2'
        d='M58.4583 42.8675C58.0521 42.93 57.6354 42.9613 57.2083 42.9613C52.3542 42.9613 48.4062 39.0342 48.4062 34.1696C48.4062 29.3154 52.3542 25.3779 57.2083 25.3779C57.6354 25.3779 58.0521 25.4092 58.4583 25.4717C54.1979 26.0758 50.9167 29.7425 50.9167 34.1696C50.9167 38.6071 54.1979 42.2738 58.4583 42.8675Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_9712'>
        <rect width='50' height='50' fill='white' transform='translate(15.5713 15)' />
      </clipPath>
    </defs>
  </svg>
));
OncologyIcon.displayName = 'OncologyIcon';

export default OncologyIcon;
